export default "__VITE_ASSET__TK$mkCnv__"